import React from "react"
import { GaObserver } from "lib/GaObserver"
import { EventAction, EventCategory, EventLabel } from "models/GoogleAnalytics"
import {
  ContentOuterContainer,
  Title,
  Text,
  WonGraphicTop,
  Container,
} from "./shared/StyledComponents"
import { Paperwork2 } from "components/Illustrations"
import { useTrackNavigatedToPage } from "hooks/useTrackPageView"

export const PaymentConfirmedPage = () => {
  useTrackNavigatedToPage("/application/status/payment-confirmed")
  return (
    <Container>
      <ContentOuterContainer>
        <GaObserver
          category={EventCategory.siteInteraction}
          action={EventAction.componentDisplay}
          label={EventLabel.bookAnAppointment}
        >
          <Title>Payment confirmed: We're now submitting your application</Title>
        </GaObserver>
        <Text>
          Thank you for completing the payment for your Mojo Specialist service. Your dedicated
          specialist team will now conduct a final review and submit your application.
        </Text>
        <Text>
          <strong>What Happens Next?</strong>
        </Text>
        <Text>
          Your Case Manager will be in touch to confirm as soon as the submission is complete.
          They’ll be your single point of contact from here and will keep you updated every step of
          the way.
        </Text>
      </ContentOuterContainer>
      <WonGraphicTop src={Paperwork2} alt="Paperwork" />
    </Container>
  )
}
